import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import {MdIconModule} from '@angular/material';

import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { NgxPageSize, NgxRefresh, NgxToggleColumn } from '../../shared/index';
import { CommonService,PurchaseInvoiceService} from '../../services/index';
import { PurchaseReturnModel } from '../../model/index';

@Component({
    selector: 'invoice-purchasesearch',
   templateUrl: './purchaseInvoiceSearch.component.html',
})
export class PurchaseInvoiceSearchComponent {
    @Input() query = '';
    @Input() searching = false;
    //@Input() fromPage;
    @Input() set initialLoad(val: boolean) {
        this.iniLoadFn(val);
    }
    @Output() purchaseSearchEmit = new EventEmitter();
    //@Output() search = new EventEmitter<string>();
    private searchTerms = new Subject<string>();

    searchVal = '';
    searchLoc = '';
    columns = [];

    filteredItems: Observable<PurchaseReturnModel[]>;

    gridList = [];
    searchTerm$ = new Subject<string>();

    page = {
        limit: 50,
        count: 10,
        offset: 0,
        orderBy: 'purchase_id',
        orderDir: 'desc',
        query: ''
    };

    constructor(private commonService: CommonService,
     private modalService: BsModalService) {
        this.loadClientSerGridList();
    }

    ngOnInit(): void {
        this.columns = [
            { name: 'Client ID', prop: 'client_no', width: 100, maxWidth: 120, toggle: true },
            { name: 'Name', prop: 'client_name', maxWidth: 150 },
            { name: 'D.O.B', prop: 'disp_dob', maxWidth: 100 },
            { name: 'Age', prop: 'age', maxWidth: 60 },
            { name: 'Address', prop: 'address', maxWidth: 150 },
            { name: 'Area', prop: 'area', maxWidth: 150 },
            { name: 'City', prop: 'city', maxWidth: 100 },
            { name: 'Mobile', prop: 'mobile', maxWidth: 115 }
        ];
        
        //this.toggleCol = Object.assign({}, this.columns);
    }
    iniLoadFn(initialLoad) {
        if (initialLoad == true) {
            this.searchTerm$.next('');
        }
    }

    loadClientSerGridList() { 
        let that = this;
        this.commonService.purchasesearch(this.searchTerm$, this.page)
            .subscribe(results => {
                that.gridList = results.data;
                that.page.count = results.totCnt;
            });
    }


    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.loadClientSerGridList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.loadClientSerGridList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    search(query: string) {
        this.searchTerms.next(query);
    }

    onSelectCustomer($event, row){
        $('.client-search-list a').removeClass('active');
        $event.currentTarget.classList.add('active');

        this.purchaseSearchEmit.emit(row);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/purchaseInvoiceSearch.component.ts